import { useEditor } from '../state/store';

/**
 * Shown at the top of the editor when a previous session left
 * unsaved changes in localStorage. The user picks:
 *   Restaurar → load the draft as current state (now dirty again)
 *   Descartar → drop the draft and stay on the server baseline
 *
 * Saving with drafts active is idempotent — the restore action just
 * re-populates state, and the user then clicks Salvar as usual.
 */
export function UnsavedDraftBanner() {
  const pending = useEditor((s) => s.pendingDraft);
  const restore = useEditor((s) => s.restoreDraft);
  const dismiss = useEditor((s) => s.dismissDraft);

  if (!pending) return null;

  const ageSec = Math.max(
    0,
    Math.round(((Date.now() - (pending.timestamp || 0)) / 1000))
  );
  const ageLabel =
    ageSec < 60
      ? `há poucos segundos`
      : ageSec < 3600
        ? `há ${Math.round(ageSec / 60)} min`
        : ageSec < 86400
          ? `há ${Math.round(ageSec / 3600)} h`
          : `há ${Math.round(ageSec / 86400)} dias`;

  return (
    <div
      role="alert"
      className="flex items-center gap-3 border-b border-warning/30 bg-warning-subdued px-4 py-2.5"
    >
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-warning/15 text-warning">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 8v4M12 16h.01" />
        </svg>
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-[13px] font-semibold text-text">
          Você tem alterações não salvas da sessão anterior
        </div>
        <div className="text-[12px] text-text-subdued">
          Draft local salvo {ageLabel}
          {Object.keys(pending.pages).length > 0 && (
            <>
              {' · '}
              {Object.keys(pending.pages).length} página
              {Object.keys(pending.pages).length === 1 ? '' : 's'} afetada
              {Object.keys(pending.pages).length === 1 ? '' : 's'}
            </>
          )}
          . Restaure para continuar de onde parou ou descarte para manter o que está no servidor.
        </div>
      </div>
      <button
        onClick={() => dismiss()}
        className="lc-btn-secondary"
        style={{ padding: '4px 12px', fontSize: 12 }}
      >
        Descartar
      </button>
      <button
        onClick={() => restore()}
        className="lc-btn-primary"
        style={{ padding: '4px 14px', fontSize: 12 }}
      >
        Restaurar
      </button>
    </div>
  );
}
